import FACEBOOK from "../../../assets/images/socials/facebook.svg";
import { Modal } from "flowbite-react";
import { useState, useContext, useEffect } from "react";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import UserContext from "../../../contexts/UserContext";
import CampaignContext from "../../../contexts/CampaignContext";
import restService from "../../../restService";

export default function Facebook({
  fetchSettings,
  messengerData,
  isLoading,
  setIsLoading,
}) {
  const [user] = useContext(UserContext);
  const [campaign] = useContext(CampaignContext);
  const [open, setOpen] = useState(false);
  const onClose = () => setOpen(false);
  const [facebookPages, setFacebookPages] = useState([]);

  function connectFunc(response) {
    if (response.accessToken) {
      fetch(
        `https://graph.facebook.com/v15.0/me/accounts?&access_token=${response.accessToken}`
      ).then((res) => {
        res.json().then((data) => {
          if (data.data.length > 0) {
            setFacebookPages(data.data);
          }

          botCreation(response.accessToken);
        });
      });
    }
  }

  function botCreation(FBUserAccessToken) {
    setIsLoading(true);
    restService.ChannelManagerServices.channelManagerServiceRegistration({
      channel_access_token: FBUserAccessToken,
      appId: campaign?.id,
      token: user?.accessToken,
      channelType: "messenger",
    })
      .then((data) => {
        fetchSettings?.();

        setFacebookPages([]);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  console.log(messengerData);

  async function DisconnectChannel() {
    setIsLoading(true);
    restService.ChannelManagerServices.disconnectSocialChannel({
      channelId: messengerData?.channelId,
      companyId: campaign?.id,
      token: user?.accessToken,
    })
      .then((data) => {
        fetchSettings?.();
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }

  return (
    <>
      <div className="shadow bg-white gap-2 justify-between py-9  px-10 w-full flex flex-col items-center">
        <div className="flex flex-col items-center gap-2 justify-center">
          <img src={FACEBOOK} alt="" />
          <div className="flex flex-col items-center gap-1">
            <p className=" text-[#626262] leading-none text-center text-xs md:text-sm w-full">
              Facebook Campaigns
            </p>
            {!messengerData ? (
              <p className="text-[12px] leading-none text-[#ff0000] font-medium">
                Disconnected
              </p>
            ) : (
              <p className="text-[12px] leading-none text-green-500 font-medium">
                Connected
              </p>
            )}
          </div>
        </div>

        <FacebookLogin
          appId={`${process.env.REACT_APP_FACEBOOK_APP_ID}`}
          autoLoad={false}
          fields="name,email,picture"
          scope="pages_messaging, pages_show_list, manage_pages, publish_pages"
          callback={connectFunc}
          icon="fa-facebook"
          render={(renderProps) => (
            <>
              {!messengerData ? (
                <button
                  disabled={isLoading}
                  className="flex mt-4 disabled:opacity-30 items-center bg-[#3989DD] border text-white rounded py-1.5 px-3 hover:shadow-lg"
                  onClick={() => {
                    renderProps.onClick();
                  }}
                >
                  Connect
                </button>
              ) : (
                <button
                  disabled={isLoading}
                  className="flex mt-4 items-center disabled:opacity-30 !border-solid text-[#ff0000] !border border-[#ff0000] rounded py-1.5 px-3 hover:shadow-lg"
                  onClick={() => {
                    DisconnectChannel();
                  }}
                >
                  Disconnect
                </button>
              )}
            </>
          )}
        />
      </div>

      {/* <Modal
        placement={"center"}
        onHide={onClose}
        show={open}
        onClose={onClose}
      >
        <div className="py-6 px-4">
          {facebookPages?.map((page) => (
            <div className="flex items-center justify-between gap-2">
              <div className="flex items-center gap-2">
                <img
                  className="img img-responsive img-circle page-img"
                  src={"https://graph.facebook.com/" + page.id + "/picture"}
                  alt="Page"
                />
                {"  " + page.name}
              </div>

              <div>
                <button
                  type="button"
                  onClick={() => {
                    botCreation(campaign?.id);
                  }}
                  className="flex mt-4 items-center bg-[#3989DD] border text-white rounded py-1.5 px-3 hover:shadow-lg"
                >
                  CONNECT TO BOT{" "}
                </button>
              </div>
            </div>
          ))}
        </div>
      </Modal> */}
    </>
  );
}
